module.exports = __webpack_public_path__ + "./docs/img/icon-enum.8859758e2bbd864ea6a586d9431b3e8e.svg";